import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'replaceLinebreak' })
export class ReplaceLinebreakPipe implements PipeTransform {
    public transform(value: string): string {
        if (value) {
            return value.replace(/\\n/g, '\n');
        }

        return '';
    }
}
